module.exports = __webpack_public_path__ + "static/media/warning.a2066d95.svg";